// HEY YOU!
// If you add any new socket cluster please put it in ALPHABETICALLY both in the import and export
// Thanks! :)
import * as adminReports from './socketCluster/adminReports'
import * as aiTools from './socketCluster/aiTools'
import * as newsTools from './socketCluster/newsTools'
import * as applicability from './socketCluster/applicability'
import * as authentication from './socketCluster/authentication'
import * as customer from './socketCluster/customer'
import * as emailReports from './socketCluster/emailReports'
import * as faqs from './socketCluster/faqs'
import * as feedback from './socketCluster/feedback'
import * as fileSharing from './socketCluster/fileSharing'
import * as filter from './socketCluster/filter'
import * as iframe from './socketCluster/iframe'
import * as notifications from './socketCluster/notifications'
import * as powerpoint from './socketCluster/powerpoint'
import * as powerpointSavedReports from './socketCluster/powerpointSavedReports'
import * as project from './socketCluster/project'
import * as referenceFiles from './socketCluster/referenceFiles'
import * as rssFeed from './socketCluster/rssFeeds'
import * as savedReport from './socketCluster/savedReport'
import * as sharedReports from './socketCluster/sharedReports'
import * as subdomain from './socketCluster/subdomain'
import * as supportDept from './socketCluster/supportDept'
import * as tableau from './socketCluster/tableau'
import * as timeFrame from './socketCluster/timeFrames'
import * as user from './socketCluster/user'
import * as userResources from './socketCluster/userResources'
import * as versioning from './socketCluster/versioning'
import * as view from './socketCluster/view'
import * as viewSheets from './socketCluster/viewSheets'

import socket from './socketCluster/socket.js'; 


export default {
  adminReports,
  aiTools,
  newsTools,
  applicability,
  authentication,
  customer,
  emailReports,
  faqs,
  feedback,
  fileSharing,
  filter,
  iframe,
  notifications,
  powerpoint,
  powerpointSavedReports,
  project,
  referenceFiles,
  rssFeed,
  savedReport,
  sharedReports,
  subdomain,
  supportDept,
  tableau,
  timeFrame,
  user,
  userResources,
  versioning,
  view,
  viewSheets,
  util: {
    connectionState() {
      return socket.state
    },
    connectionEvent(cb) {
      (async () => {
        for await (const event of socket.listener('connect')) {
          cb(event)
          break
        }
      })()
    },
    disconnectEvent(cb) {
      (async () => {
        for await (const event of socket.listener('disconnect')) {
          cb(event)
          break
        }
      })()
    },
    rawEvent(cb) {
      (async () => {
        for await (const event of socket.listener('raw')) {
          cb(event)
          break
        }
      })()
    },
    unbindEvent(event, cb) {
      socket.listener(event).removeListener(cb)
    },
    getAuthToken() {
      return socket.authToken
    },
    connect() {
      socket.connect()
    },
    getSocketId() {
      return socket.id
    }
  }
}